
    import './styles.scoped.css';
    export default {
  "code-editor-refresh": "awsui_code-editor-refresh_1gl9c_19v2n_104",
  "code-editor": "awsui_code-editor_1gl9c_19v2n_104",
  "pane": "awsui_pane_1gl9c_19v2n_450",
  "pane__close-container": "awsui_pane__close-container_1gl9c_19v2n_461",
  "pane__list": "awsui_pane__list_1gl9c_19v2n_466",
  "pane__table": "awsui_pane__table_1gl9c_19v2n_473",
  "pane__item": "awsui_pane__item_1gl9c_19v2n_479",
  "pane__cell": "awsui_pane__cell_1gl9c_19v2n_479",
  "pane__item--highlighted": "awsui_pane__item--highlighted_1gl9c_19v2n_493",
  "pane__location": "awsui_pane__location_1gl9c_19v2n_514",
  "pane__description": "awsui_pane__description_1gl9c_19v2n_514",
  "focus-lock": "awsui_focus-lock_1gl9c_19v2n_529",
  "editor": "awsui_editor_1gl9c_19v2n_580",
  "editor-refresh": "awsui_editor-refresh_1gl9c_19v2n_608",
  "status-bar": "awsui_status-bar_1gl9c_19v2n_613",
  "status-bar-with-hidden-pane": "awsui_status-bar-with-hidden-pane_1gl9c_19v2n_621",
  "status-bar__left": "awsui_status-bar__left_1gl9c_19v2n_625",
  "status-bar__left-virtual": "awsui_status-bar__left-virtual_1gl9c_19v2n_632",
  "status-bar__right": "awsui_status-bar__right_1gl9c_19v2n_636",
  "status-bar__language-mode": "awsui_status-bar__language-mode_1gl9c_19v2n_640",
  "status-bar__cursor-position": "awsui_status-bar__cursor-position_1gl9c_19v2n_640",
  "status-bar__cog-button": "awsui_status-bar__cog-button_1gl9c_19v2n_646",
  "status-bar-virtual": "awsui_status-bar-virtual_1gl9c_19v2n_651",
  "tab-button": "awsui_tab-button_1gl9c_19v2n_657",
  "tab-button--refresh": "awsui_tab-button--refresh_1gl9c_19v2n_689",
  "tab-button--warnings": "awsui_tab-button--warnings_1gl9c_19v2n_692",
  "tab-button--active": "awsui_tab-button--active_1gl9c_19v2n_701",
  "tab-button--disabled": "awsui_tab-button--disabled_1gl9c_19v2n_717",
  "tab-button--divider": "awsui_tab-button--divider_1gl9c_19v2n_750",
  "tab-button--errors": "awsui_tab-button--errors_1gl9c_19v2n_757",
  "loading-screen": "awsui_loading-screen_1gl9c_19v2n_761",
  "error-screen": "awsui_error-screen_1gl9c_19v2n_762"
};
  